import React from 'react'
import {CgLoadbarAlt} from "react-icons/cg"
import {BsPlusLg} from "react-icons/bs"
import "./Mint.css"
const Mint = () => {
  return (
    <div className=' flex flex-col w-full h-[70vh] relative' id="mint">
        <div className=' container mx-auto w-full mt-20 h-full justify-center items-center flex flex-col'>
            
                 <div className=' w-full h-auto font-medium text-5xl justify-center items-center flex text-white'>
                    <h4>Mint</h4>
                </div>
            <div className=' w-full justify-center items-center h-full flex flex-col '>
           

                <div className=' flex flex-row w-full h-auto px-40 '>
                    <div className=' babel-1'>

                    </div>
                    <div className=' babel-2'>

                    </div>
                    <div className=' flex flex-col w-1/2 mx-10 '>
                        <div className='flex flex-col w-full relative  border-[3px] border-b-yellow-300  border-t-pink-700  border-r-yellow-300   border-l-pink-700  py-[40px] mint-1 mt-20  px-10 main-mint '>
                            <div className=' flex   flex-row w-full h-auto rounded-sm   text-white font-iceberg justify-center py-2 items-center '>
                                <h5 className='text-5xl font-bold sales'>Sales</h5>
                            </div>
                        {/* <div className=' flex mt-4   flex-row w-full h-auto text-white justify-between items-center'>
                            <button className=' bg-gray-400 py-3 px-3 text-black'><CgLoadbarAlt/></button>
                            <strong className=' text-3xl font-bold text-white'>05</strong>
                            <button className=' bg-gray-400 py-3 px-3 text-black'><BsPlusLg/></button>
                            <span className='bg-gray-400 py-2 px-2  text-gray-800'>Max</span>
                        </div> */}
                            <div className=' flex flex-col w-full h-auto mt-10'>
                                <span className=' text-white font-iceberg text-xl'>100/1000</span>
                                <span className=' text-white text-xl font-iceberg mt-10'>April / 25<sup>th</sup></span>
                            </div>
                        </div>
                        <div className=' flex  flex-row w-full mt-9 h-auto text-white justify-center items-center'>
                            <button className=' relative z-10 mint-btn  py-2 w-full font-iceberg border-[1px]  font-bold text-center  rounded-xl text-2xl'>Mint</button>
                        </div>
                    </div>
                    <div className='w-1/2 flex-col  mx-10  font-iceberg '>
                        <div className='w-[70%] flex-col border-white  rounded-xl mint-3 border-[1px] py-2 mt-20 px-10 '>
                            <div className=' flex  mt-4 flex-row w-full h-auto text-white justify-between items-center'>
                                <span className=' text-2xl'>10%</span>
                            </div>
                            <div className=' flex mt-3 flex-row w-full h-auto text-white justify-between items-center'>
                                <span className=' text-2xl'>20%</span>
                                <strong>05 users</strong>
                            </div>
                            <div className=' flex  mt-3 flex-row w-full h-auto text-white justify-between items-center'>
                                <span className=' text-2xl'>3%</span>
                                <strong>Future users</strong>
                            </div>
                            <div className=' flex  mt-3 flex-row w-full h-auto text-white justify-between items-center'>
                                <span className=' text-2xl'>2%</span>
                                <strong>Future users</strong>
                            </div>
                        </div>
                        <div className=' w-[70%] h-auto flex flex-col mint-4 rounded-xl border-white border-[1px] py-2 mt-10 px-10 '>
                            <div className=' w-full h-auto flex flex-col justify-center items-center'>
                                <span className=' text-white text-2xl'>Pre Sale</span>
                            </div>
                         
                            <span className=' text-white text-xl mt-4'>10/1000</span>
                            <span className=' text-white text-xl mt-4'>April / 25<sup>th</sup></span>
                        </div>
                    </div>
                  
                    
                </div>
               
            </div>
        </div>
    </div>
  )
}

export default Mint